import React from 'react';

export default function CheckIcon(props) {
  return (
    <svg
      width={10}
      height={8}
      viewBox="0 0 10 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.5 4.40001L3.523 6.42301C3.5657 6.46571 3.6343 6.46571 3.677 6.42301L8.5 1.60001"
        stroke="#C7D2DD"
        strokeWidth={1.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
